import React from "react";
import { Search, Eraser, FileUp, UserPlus, Plus } from "lucide-react";

/**
 * Top toolbar of the User Management page: search box + bulk-import / reset-demo /
 * onboard / add-user buttons. Stateless — parent owns the search filter and the
 * action callbacks.
 */
export default function UserFilters({
  filter, onFilterChange,
  status, onStatusChange, statusCounts,
  canBulkImport, onBulkReimport,
  canResetDemo, onResetDemo,
  canOnboard, onOnboard,
  canCreate, onCreate,
}) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      <div className="relative">
        <Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
        <input
          value={filter}
          onChange={(e) => onFilterChange(e.target.value)}
          placeholder="Search…"
          className="pl-9 pr-3 py-2 text-sm border border-slate-200 rounded-md bg-white w-64"
          data-testid="user-search-input"
        />
      </div>
      <select value={status} onChange={(e) => onStatusChange(e.target.value)} className="py-2 pl-3 pr-8 text-sm border border-slate-200 rounded-md bg-white" data-testid="user-status-filter" aria-label="Status filter">
        <option value="current">Current staff ({statusCounts.current})</option>
        <option value="active">Active only ({statusCounts.active})</option>
        <option value="inactive">Inactive ({statusCounts.inactive})</option>
        <option value="former">Former Staff ({statusCounts.former})</option>
        <option value="all">Everyone ({statusCounts.all})</option>
      </select>
      {canBulkImport && (
        <button onClick={onBulkReimport} className="inline-flex items-center gap-2 px-3.5 py-2 rounded-md border border-slate-200 hover:border-sky-400 text-slate-700 hover:text-sky-800 text-sm font-semibold bg-white" data-testid="bulk-reimport-btn" title="Import a CSV / Excel staff directory with review">
          <FileUp size={14} /> Bulk Re-import
        </button>
      )}
      {canResetDemo && (
        <button onClick={onResetDemo} className="inline-flex items-center gap-2 px-3.5 py-2 rounded-md border border-rose-200 hover:bg-rose-50 text-rose-700 text-sm font-semibold bg-white" data-testid="reset-demo-btn" title="Wipe all scores + QA audits (keeps users)">
          <Eraser size={14} /> Reset Demo Data
        </button>
      )}
      {canOnboard && (
        <button onClick={onOnboard} className="inline-flex items-center gap-2 px-3.5 py-2 rounded-md bg-emerald-600 hover:bg-emerald-700 text-white text-sm font-semibold" data-testid="onboard-staff-btn">
          <UserPlus size={14} /> Onboard New Staff
        </button>
      )}
      {canCreate && (
        <button onClick={onCreate} className="inline-flex items-center gap-2 px-3.5 py-2 rounded-md bg-sky-800 hover:bg-sky-900 text-white text-sm font-semibold" data-testid="add-user-btn">
          <Plus size={14} /> Add User
        </button>
      )}
    </div>
  );
}
